import { Breadcrumb, Button, Card, Col, Empty, Form, Input, message, Row, Select, Table } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import gql from 'graphql-tag';
import queryString from 'query-string';
import React, { Component, FormEvent } from 'react';
import { Query } from 'react-apollo';
import { Link, RouteComponentProps } from 'react-router-dom';

import { Panel } from '../../components/Panel';
import { WorkOrder, WorkOrderPriority, WorkOrderStatus, WorkOrderType } from './type';

const FormItem = Form.Item;

export const WorkOrderTypeList = {
  [WorkOrderType.UNKNOWN]: '未知',
  [WorkOrderType.REDEEM_CODE_REFUND]: '兑换码退款',
  [WorkOrderType.NO_PURCHASE_ORDER_REFUND]: '无订单退款',
  [WorkOrderType.REFUND_FAIL]: '退款失败',
  [WorkOrderType.REFUND_QUERY_FAIL]: '退款查询失败',
};

export const WorkOrderPriorityList = {
  [WorkOrderPriority.LOW]: '低',
  [WorkOrderPriority.NORMAL]: '普通',
  [WorkOrderPriority.HIGH]: '高',
  [WorkOrderPriority.URGENT]: '紧急',
};

export const WorkOrderStatusList = {
  [WorkOrderStatus.CREATED]: '创建',
  [WorkOrderStatus.PROCESSING]: '处理中',
  [WorkOrderStatus.DONE]: '完结',
  [WorkOrderStatus.REOPENED]: '重新打开',
};

export const workOrdersQuery = gql`
  query getWorkOrdersQuery(
    $ids: [ID]
    $title: String
    $priority: Int
    $eventSource: Int
    $type: Int
    $status: Int
    $pagination: Pagination
  ) {
    workOrders(
      ids: $ids
      title: $title
      priority: $priority
      eventSource: $eventSource
      type: $type
      status: $status
      pagination: $pagination
    ) {
      id
      status
      eventId
      eventSource
      type
      priority
      title
      histories {
        id
        description
        performedById
        workOrderId
        workOrderStatus
      }
      metadata {
        amount
        reason
        userId
      }
    }
  }
`;

interface States {
  currentSkuId?: number;
  pageSize: number;
  current: number;

  variables: {
    status?: WorkOrderStatus;
    priority?: WorkOrderPriority;
    type?: WorkOrderType;
    ids?: string[];
  };
}

interface WorkOrderListData {
  workOrders: WorkOrder[];
}

type Props = RouteComponentProps<{ id: string }> & { form: WrappedFormUtils };
export class WorkOrderListForm extends Component<Props, States> {
  constructor(props: Props) {
    super(props);
    this.state = {
      pageSize: 50,
      current: 1,
      variables: {},
    };

    this.onResetClick = this.onResetClick.bind(this);
  }

  async componentDidMount() {
    const {
      location: { search },
    } = this.props;
    const { pageIndex } = queryString.parse(search);
    if (pageIndex) {
      this.setState({
        current: Number(pageIndex),
      });
    }
  }

  onResetClick() {
    this.props.form.resetFields();
  }

  toSelectChange = (current: number) => {
    this.setState({
      current,
    });
  };

  setCurrent = (current: number) => {
    this.setState({
      current,
    });
  };

  search = (e: FormEvent) => {
    let ids: string[] = [];
    this.props.form.validateFields((err, values) => {
      if (err) {
        message.error(err);
        return;
      }
      if (values.workOrderId) {
        ids = [values.workOrderId];
      }
      const variables = {
        ids: values.workOrderId,
        priority: values.priority,
        status: values.workOrderStatus,
        type: values.workOrderType,
      };
      this.setState({
        variables,
      });
    });

    e.preventDefault();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>工单管理</Breadcrumb.Item>
        </Breadcrumb>
        <Card>
          <h2>工单信息</h2>
        </Card>
        <Query<WorkOrderListData>
          query={workOrdersQuery}
          variables={this.state.variables}
          fetchPolicy="cache-and-network"
        >
          {({ loading, error, data }) => {
            if (error) return <div>{error.message}</div>;
            if (loading) return <div>loading...</div>;
            if (!data) {
              // @ts-ignore
              return <Empty />;
            }
            const { workOrders } = data;
            return (
              <>
                <Panel style={{ padding: 24 }}>
                  <Form onSubmit={this.search}>
                    <Row gutter={24}>
                      <Col xs={24} md={24} lg={8} xl={8} xxl={8}>
                        <FormItem label={`工单ID`}>
                          {getFieldDecorator('workOrderId')(<Input placeholder="请输入工单ID" allowClear />)}
                        </FormItem>
                      </Col>
                      <Col xs={24} md={24} lg={8} xl={8} xxl={8}>
                        <FormItem label={`工单状态`}>
                          {getFieldDecorator('workOrderStatus')(
                            <Select placeholder="请选择工单状态" allowClear>
                              {Object.keys(WorkOrderStatusList).map(status => {
                                return (
                                  <Select.Option key={status} value={status}>
                                    {WorkOrderStatusList[status]}
                                  </Select.Option>
                                );
                              })}
                            </Select>,
                          )}
                        </FormItem>
                      </Col>
                      <Col xs={24} md={24} lg={8} xl={8} xxl={8}>
                        <FormItem label={`工单优先级`}>
                          {getFieldDecorator('priority')(
                            <Select placeholder="请选择工单优先级" allowClear>
                              {Object.keys(WorkOrderPriorityList).map(priority => {
                                return (
                                  <Select.Option key={priority} value={priority}>
                                    {WorkOrderPriorityList[priority]}
                                  </Select.Option>
                                );
                              })}
                            </Select>,
                          )}
                        </FormItem>
                      </Col>
                    </Row>
                    <Row type="flex" justify="end">
                      <Button icon="search" type="primary" style={{ marginRight: 8 }} htmlType="submit">
                        搜索
                      </Button>
                      <Button style={{ marginRight: 8 }} type="primary" onClick={this.onResetClick}>
                        重置
                      </Button>
                    </Row>
                  </Form>
                </Panel>
                <Panel style={{ marginTop: 16 }}>
                  <Table
                    dataSource={workOrders}
                    pagination={{
                      // 分页
                      current: this.state.current,
                      total: workOrders.length, // 数据总数量
                      pageSize: this.state.pageSize, // 显示几条一页
                      defaultPageSize: 50, // 默认显示几条一页
                      showSizeChanger: true, // 是否显示可以设置几条一页的选项
                      onShowSizeChange: (current, pageSize) => {
                        this.toSelectChange(current);
                      },
                      onChange: current => {
                        // 点击改变页数的选项时调用函数，current:将要跳转的页数
                        this.setCurrent(current);
                        this.props.history.push(`/work-order/list?pageIndex=${current}`);
                      },
                      showTotal: () => {
                        // 设置显示一共几条数据
                        return `共 ${workOrders.length} 个工单`;
                      },
                    }}
                    rowKey={record => `${record.id}`}
                  >
                    <Table.Column title="ID" dataIndex="id" key="id" />
                    <Table.Column
                      title="优先级"
                      render={priority => WorkOrderPriorityList[priority]}
                      dataIndex="priority"
                    />
                    <Table.Column title="标题" dataIndex="title" />
                    <Table.Column
                      title="状态"
                      render={status => WorkOrderStatusList[status]}
                      dataIndex="status"
                      key="status"
                    />
                    <Table.Column title="分类" render={type => WorkOrderTypeList[type]} dataIndex="type" key="type" />
                    <Table.Column
                      title="操作"
                      dataIndex="id"
                      key="action"
                      render={id => <Link to={`/work-order/${id}`}>详情</Link>}
                    />
                  </Table>
                </Panel>
              </>
            );
          }}
        </Query>
      </div>
    );
  }
}

export const WorkOrderList = Form.create({ name: 'WorkOrderList' })(WorkOrderListForm);



// WEBPACK FOOTER //
// ./src/screens/workOrder/WorkOrderList.tsx